import { IMailTask } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const postSendInvoiceToEmail = ({
  invoiceId,
  payload,
}: {
  invoiceId: string;
  payload: IMailTask;
}) =>
  API.post(`/api/documents/invoices/${invoiceId}/email`, payload).then(response => response?.data);
